import { CREATE_ITEM_TYPE } from '../../../constants';
import type { EnrichedCreateItem, FlatItem } from '../../../types';
import { isBaseLevel } from '../../../utils/hierarchy-enriched-items';
import { isParentCreateItem } from './get-child-item';
import type { RenderCreateItem, RenderItemContainer } from './types';

// REMOVE THE FOLLOWING DURING JWM.VISUAL-HIERARCHY-MILESTONE-1 CLEANUP
export const getPlaceholderCreateItem = (
	shouldRenderContainer: boolean,
	enrichedCreateItem: EnrichedCreateItem<FlatItem> | undefined,
	renderItemContainer: RenderItemContainer,
	renderCreateItem: RenderCreateItem,
) => {
	// if shouldRenderContainer is true, it means the createPosition has a value which means it's out of view

	if (enrichedCreateItem !== undefined && enrichedCreateItem.type === CREATE_ITEM_TYPE) {
		const createItem = renderCreateItem(enrichedCreateItem.anchorItem, enrichedCreateItem.meta);

		if (
			shouldRenderContainer &&
			!isParentCreateItem(enrichedCreateItem) &&
			enrichedCreateItem.anchorItem !== undefined
		) {
			const { anchorItem, meta } = enrichedCreateItem;
			const parentId = !isBaseLevel(anchorItem.level) ? anchorItem.id : meta.parentId;

			if (parentId !== undefined) {
				// render the create child item in a container if it is a child and the parent item is not visible
				return renderItemContainer(
					{
						parentId: undefined,
						isExpanded: true,
						isParent: true,
						id: parentId,
						level: 1,
						startOffset: meta.parentStartOffset,
						ariaRowIndex: meta.ariaRowIndex,
						isInTransition: false,
					},
					0,
					createItem,
				);
			}
		}

		return createItem;
	}
	return undefined;
};
